const LoaderSpinner = () => {
    return (
        <div role="status">
            <img className='w-16 h-8' src="/loader.svg" alt="loader-img" />
        </div>
    )
}
export default LoaderSpinner;